export default "__VITE_ASSET__a1841ff3__"